'use strict';

module.exports = Object.freeze({
  CLASS_A : 'classA',
  CLASS_B : 'classB',
  CLASS_C : 'classC',
});